import React, { Component, useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Grid, TextField, Button, CircularProgress, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Box, Chip, Tooltip, DialogActions, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import { DataTable, DatePicker, TableBody, TableColumn, TableHeader, TimePicker } from 'react-md';
import Toggle from 'react-toggle';
import TextEditor from '../../../component/TextEditor';
import { MdDragIndicator } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BsInfoCircleFill } from "react-icons/bs";
import { PiCaretUpBold, PiCaretDownBold } from "react-icons/pi";
import { IoIosCloseCircle } from "react-icons/io";
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import { DEFAULT_AT_FIRST, DEFAULT_AT_LAST, DEFAULT_MASTERY_COUNT, DEFAULT_NOCQC, DEFAULT_RADNOM_SUBCATEGORY_ORDER, DEFAULT_REQUIRED } from '../Constants';
import CategoryOptionsModal from './CategoryOptionsModal';
import { AppProperties } from '../../../common/function';
import HelpText from '../../../lib/help-text';
import EditWindow from '../../EditWindow';
import CollapsableColumn from '../../../component/CollapsableColumn';
import { TableRow as TableRowReact } from 'react-md';
import editIcon from '../../../images/png/edit.png';
import crossIcon from '../../../images/png/crossIcon.png';

class AssignmentDetailModal extends Component {

    helpTextModel = new HelpText();

    appProperties = AppProperties();

    constructor(props) {
        super(props);
        this.state = {
            showCategoryOptions: false,
            assignment: this.props.assignment,
            saveLoading: false,

            // For date
            startDate: "",
            endDate: "",

            // For splash screen
            splashTextEditorObj: null,
            splashScreenText: "",
            altSplashScreenTextVisible: false,
            imgTagCount: 0,
            altSplashScreenText: "",

            // Section
            sections: [],
            subsections: [],
            hasSubSections: false,
            enableSubSection: false,
            selectedSectionIDArr: [],
            selectedSubsectionsArr: [],
            selectedSectionAndSubsectionList: [],

            // Cat Subcategory table
            subcategories: [],
            categories: [],

            // Freechoice 
            freeChoiceCount: 0,

            // Extend
            showEditDueDates: false,
            showSectionsAndSubsectionsDialog: false
        };
    }

    componentDidMount() {
        this.updateOnMountState();
        if (this.props.course_id) {
            this.getCourseSections();
        }
    }

    getCourseSections = () => {
        let payload = {
            course_id: this.props.course_id
        }
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
        }).then(async (res) => {
            if (res && res.data && res.data.data) {
                let sectionsArr = res.data.data.section_names;
                let subsectionsArr = [];
                let hasSubSections = false;

                let index = sectionsArr.findIndex(sec => sec.enable_subsection);
                if (index >= 0) hasSubSections = true;

                let selectedSectionAndSubsectionList = [];

                // get all subections for sections has enabled
                for (let i = 0; i < sectionsArr.length; i++) {
                    const section = sectionsArr[i];
                    if (section.enable_subsection) {
                        const subsections = await this.getSubsections({
                            course_id: this.props.course_id,
                            section_id: section.section_id
                        })
                        subsectionsArr.push(...subsections);

                        // check if this subsection is present in assignment 
                        if (this.state.assignment.sections_list && this.state.assignment.sections_list.length) {
                            let sectionIndex = this.state.assignment.sections_list.findIndex(sec => sec.id === section.section_id);
                            if (sectionIndex > -1) {
                                selectedSectionAndSubsectionList.push({
                                    section_id: section.section_id,
                                    section_name: section.section_name,
                                    subsectionList: subsections.filter(subSec => subSec.section_id === section.section_id),
                                    subsection: subsections.filter(subSec => subSec.section_id === section.section_id).map(subSec => subSec.subsection_name)
                                })
                            }
                        }
                    }
                }

                //console.debug("selectedSectionAndSubsectionList>>", selectedSectionAndSubsectionList)

                this.setState({
                    sections: sectionsArr,
                    subsections: subsectionsArr,
                    selectedSectionAndSubsectionList: selectedSectionAndSubsectionList,
                    hasSubSections,
                })
            }
        })
    }

    getSubsections = async (payload) => {
        const res = await ApiRequestService({
            method: 'post',
            url: '/getAllSubSections',
            data: payload
        })
        if (res.data && res.data.data && res.data.data.subsection_names != null && res.data.data.subsection_names.length > 0) {
            return res.data.data.subsection_names;
        } else {
            return [];
        }
    }


    updateOnMountState = () => {
        let assignment = this.props.assignment;
        if (assignment) {
            let obj = TextEditor.createValueFromString(
                assignment.splash_screen,
                'html'
            )

            //console.debug("assignment>>??", assignment);

            let subcategories = assignment.quiz_subcat_info;
            if (subcategories) {
                subcategories.sort((subcat1, subcat2) => {
                    return subcat1.order - subcat2.order;
                })
            }

            let selectedSectionIDArr = assignment.sections_list && assignment.sections_list.length ? assignment.sections_list.map(sec => sec.id) : [];

            let categoryMasteryCountJSON = assignment?.category_mastery_count ? JSON.parse(assignment.category_mastery_count) : {};
            let categoryNocqcJSON = assignment?.category_nocqc ? JSON.parse(assignment.category_nocqc) : {};
            let randomSubcategoryOrderJSON = assignment?.random_subcategory_order ? JSON.parse(assignment.random_subcategory_order) : {};
            let categoryIsRequiredJSON = assignment?.category_is_required ? JSON.parse(assignment.category_is_required) : {};
            let categoryPositionJSON = assignment?.category_position ? JSON.parse(assignment.category_position) : {};
            let categoryNoOfQuestionsJSON = assignment?.category_number_of_questions ? JSON.parse(assignment.category_number_of_questions) : {};

            let categories = [];
            let seenCategoryKeys = new Set();
            if (assignment.quiz_details) {
                assignment.quiz_details.forEach(category => {
                    const catKey = `${category.subject_id}_${category.topic_id}_${category.category_id}`;
                    if (!seenCategoryKeys.has(catKey)) {
                        let obj = assignment.quiz_subcat_info.find(subcat => {
                            let key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                            return catKey == key;
                        })
                        let cat = {
                            ...category,
                            masteryCount: categoryMasteryCountJSON[catKey] ? categoryMasteryCountJSON[catKey] : DEFAULT_MASTERY_COUNT,
                            nocqc: categoryNocqcJSON[catKey] ? categoryNocqcJSON[catKey] : DEFAULT_NOCQC,
                            randomSubcategoryOrder: randomSubcategoryOrderJSON[catKey] ? randomSubcategoryOrderJSON[catKey] : DEFAULT_RADNOM_SUBCATEGORY_ORDER,
                            required: categoryIsRequiredJSON[catKey] ? categoryIsRequiredJSON[catKey] : DEFAULT_REQUIRED,
                            atFirst: categoryPositionJSON[catKey] ? categoryPositionJSON[catKey].category_at_begining : DEFAULT_AT_FIRST,
                            atLast: categoryPositionJSON[catKey] ? categoryPositionJSON[catKey].category_at_last : DEFAULT_AT_LAST,
                            noOfQuestion: categoryNoOfQuestionsJSON[catKey] ? categoryNoOfQuestionsJSON[catKey] : 0,
                            subject_name: obj?.subject_name ? obj?.subject_name : "",
                            topic_name: obj?.topic_name ? obj?.topic_name : "",
                        }
                        categories.push(cat);
                    }
                    seenCategoryKeys.add(catKey);
                })
            }

            //console.debug("subcategories>>??", subcategories)

            this.setState({
                splashTextEditorObj: obj,
                splashScreenText: assignment.splash_screen,
                altSplashScreenText: assignment.alt_splash_screen,
                enableSubSection: assignment.enable_subsection,
                hasSubSections: assignment.show_enable_subsection,
                subcategories: subcategories,
                selectedSectionIDArr: selectedSectionIDArr,
                categories: categories,
                freeChoiceCount: assignment.free_choice_count,
            })
        }

        var startDateAndTime = assignment.start_date + ' ' + assignment.start_time;
        var endDateAndTime = assignment.end_date + ' ' + assignment.end_time;
        var resStartDate = '';
        var resEndDate = '';
        if (
            assignment.start_date !== null &&
            assignment.start_date !== ''
        ) {
            resStartDate = moment(startDateAndTime, 'DD-MM-YYYY HH-mm');
        }
        if (
            assignment.end_date !== null &&
            assignment.end_date !== ''
        ) {
            resEndDate = moment(endDateAndTime, 'DD-MM-YYYY HH-mm');
        }
        this.setState({
            startDate: resStartDate,
            endDate: resEndDate,
        })
    }

    onDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(this.state.subcategories);
        const [reordered] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reordered);

        const reorderedWithOrder = items.map((item, idx) => ({
            ...item,
            order: idx + 1
        }));

        let updatedSubcategories = this.markInvalidSubcategoryOrder(reorderedWithOrder);
        this.setState({
            subcategories: updatedSubcategories,
        });
    };

    handleSaveClick = (statusArg) => {
        let tempstartDate = this.state.startDate;
        let tempendDate = this.state.endDate;

        if (tempstartDate === "") {
            NotificationManager.error("Start date should not be empty");
            return;
        }
        if (tempendDate === "") {
            NotificationManager.error("End date should not be empty");
            return;
        }

        let startDate = tempstartDate.format('DD/MM/YYYY');
        tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
        let startTime = tempstartDate[1];

        let endDate = tempendDate.format('DD/MM/YYYY');
        tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
        let endTime = tempendDate[1];

        let tempAltSplashScreenText = this.state.altSplashScreenText;

        // Validate splash screen images
        if (this.state.imgTagCount >= 1) {
            let tempaltSplashScreen = tempAltSplashScreenText
            tempaltSplashScreen = tempaltSplashScreen.replace(/\n/ig, '')
            tempaltSplashScreen = tempaltSplashScreen.replace(/ /g, '')
            let attrTextArr = tempaltSplashScreen.split(';')
            attrTextArr = attrTextArr.filter(function (el) {
                return el !== "";
            });
            //console.debug(attrTextArr)
            var attrTextCount = attrTextArr.length
            //console.debug(tempaltSplashScreen, " ", (attrTextCount % 2), " ", this.state.imgTagCount, " === ", (attrTextCount / 2), "  ", attrTextCount)
            if (tempaltSplashScreen === '') {
                alert('"Title and Alternative Text for all Images in SplashScreen" is Empty. Please enter a valid text.');
                return;
            }
            if ((attrTextCount % 2) !== 0) {
                alert('Title or Alternative text is missing in "Title and Alternative Text for all Images in SplashScreen"');
                return;
            }

            if (this.state.imgTagCount !== (attrTextCount / 2)) {
                alert('Please enter a valid text for all images in "Title and Alternative Text for all Images in SplashScreen"');
                return;
            }
            var lastChar = tempaltSplashScreen[tempaltSplashScreen.length - 1];
            if (lastChar === ";") {
                alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images in SplashScreen"');
                return;
            }
        }

        let sectionList = [];
        // TODO: fix this when enable_subsections is turned ON
        if (this.state.enableSubSection) {
            this.state.selectedSectionAndSubsectionList.forEach(sec => {
                //console.debug("sec>>??", sec)
                sec.subsectionList.forEach(subSec => {
                    sectionList.push({
                        id: sec.section_id,
                        ...subSec,
                    });
                })
            })
        } else {
            this.state.selectedSectionIDArr.forEach(id => {
                let section = this.state.sections.find(sec => sec.section_id === id);
                if (section) {
                    sectionList.push({
                        id: section.section_id,
                        ...section
                    });
                }
            })
        }

        let sectionDeleteArr = [];
        if (this.state.assignment.sections_list && this.state.assignment.sections_list.length) {
            sectionDeleteArr = [...this.props.assignment.sections_list,];
        }

        let assignment = { ...this.state.assignment };
        const categorySums = {}
        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            const questionCount = cat.question_count || 0;

            if (!categorySums[key]) {
                categorySums[key] = 0;
            }

            categorySums[key] += questionCount;
        });

        this.state.categories.forEach(cat => {
            let pickedCategoryKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            let masteryCount = cat.masteryCount;
            let noCQC = cat.nocqc;
            let randomSubcategoryOrder = cat.randomSubcategoryOrder;
            let required = cat.required;
            let noOfQuestion = cat.noOfQuestion;
            let atFirst = cat.atFirst;
            let atLast = cat.atLast;
            let availableQuestions = categorySums[pickedCategoryKey];

            if (assignment.category_mastery_count === "") {
                assignment.category_mastery_count = JSON.stringify({
                    [pickedCategoryKey]: masteryCount,
                });
            } else {
                const existingData = JSON.parse(assignment.category_mastery_count);
                existingData[pickedCategoryKey] = masteryCount;
                assignment.category_mastery_count = JSON.stringify(existingData);
            }

            if (assignment.category_nocqc === "") {
                assignment.category_nocqc = JSON.stringify({
                    [pickedCategoryKey]: noCQC,
                });
            } else {
                const existingData = JSON.parse(assignment.category_nocqc);
                existingData[pickedCategoryKey] = noCQC;
                assignment.category_nocqc = JSON.stringify(existingData);
            }

            if (assignment.random_subcategory_order === "") {
                assignment.random_subcategory_order = JSON.stringify({
                    [pickedCategoryKey]: randomSubcategoryOrder,
                });
            } else {
                const existingData = JSON.parse(assignment.random_subcategory_order);
                existingData[pickedCategoryKey] = randomSubcategoryOrder;
                assignment.random_subcategory_order = JSON.stringify(existingData);
            }

            if (assignment.category_is_required === "") {
                assignment.category_is_required = JSON.stringify({
                    [pickedCategoryKey]: required,
                });
            } else {
                const existingData = JSON.parse(assignment.category_is_required);
                existingData[pickedCategoryKey] = required;
                assignment.category_is_required = JSON.stringify(existingData);
            }

            if (assignment.category_number_of_questions === "") {
                assignment.category_number_of_questions = JSON.stringify({
                    [pickedCategoryKey]: noOfQuestion !== 0 ? noOfQuestion : availableQuestions,
                });
            } else {
                const existingData = JSON.parse(assignment.category_number_of_questions);
                existingData[pickedCategoryKey] = noOfQuestion !== 0 ? noOfQuestion : availableQuestions;
                assignment.category_number_of_questions = JSON.stringify(existingData);
            }

            if (assignment.category_position === "") {
                assignment.category_position = JSON.stringify({
                    [pickedCategoryKey]: {
                        category_at_begining: atFirst,
                        category_at_last: atLast,
                    },
                });
            } else {
                const existingData = JSON.parse(assignment.category_position);
                existingData[pickedCategoryKey] = {
                    category_at_begining: atFirst,
                    category_at_last: atLast,
                };
                assignment.category_position = JSON.stringify(existingData);
            }
        })

        let payload = {
            ...assignment,
            quiz_delete_arr: this.props.assignment.quiz_details,
            splash_screen: this.state.splashScreenText,
            alt_splash_screen: this.state.altSplashScreenText,
            start_date: startDate,
            start_time: startTime,
            end_date: endDate,
            end_time: endTime,
            sections_delete_list: sectionDeleteArr,
            sections_list: sectionList,
            quiz_delete_arr: [
                ...this.state.assignment.quiz_subcat_info,
                this.state.subcategories,
            ],
            quiz_details: this.state.subcategories,
            quiz_subcat_info: this.state.subcategories,
            free_choice_count: this.state.freeChoiceCount,
            allow_practice: assignment.quiz_type === 0, //all quizzes are practicable
            enable_subsection: this.state.enableSubSection,
            status: statusArg,
        }

        // TODO check if payload is valid

        if (payload.quiz_name === "") {
            NotificationManager.error("Assignment name cannot be empty");
            return;
        }

        if (payload.start_date === "" || payload.start_time === "" || payload.end_date === "" || payload.end_time === "") {
            NotificationManager.error("Please fill the date fields");
            return;
        }

        if (payload.sections_list === null || payload.sections_list?.length === 0) {
            let msg = "Please add atleast one section"
            if (payload.enable_subsection) {
                msg = "Please add atleast one section & subsection"
            }
            NotificationManager.error(msg);
            return;
        }

        // check if atlease one subcategories is present
        if (payload.quiz_subcat_info === null || payload.quiz_subcat_info === undefined || payload.quiz_subcat_info.length === 0) {
            NotificationManager.error("Atleast one subcategory should be added to the assignment");
            return
        }

        if (!this.validateSubcategoryOrder(this.state.subcategories)) {
            NotificationManager.error("Please ensure that all the subcategories of a category are placed sequentially next to each other and are not spread out.", "Invalid Subcategory Order", 3000);
            return false;
        }

        //console.debug("payload>>??", payload)

        this.setState({
            saveLoading: true,
        })
        ApiRequestService({
            method: 'post',
            url: '/addQuiz',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                NotificationManager.success("Saved successully", "Success", 3000)
                this.setState({ saveLoading: false });
                this.props.onSaveAssignment(res.data.data);
            }
        }).finally(() => {
            this.setState({ saveLoading: false });
        })

    }

    markInvalidSubcategoryOrder = (subcategories) => {
        const seenCategoryKeys = [];
        const lastSeenIndex = {};
        let updatedSubcategories = subcategories.map((subcat, index) => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
            const isNewGroup = !seenCategoryKeys.includes(key);

            if (isNewGroup) {
                seenCategoryKeys.push(key);
                lastSeenIndex[key] = index;
                return { ...subcat, invalid: false };
            } else {
                // If it's continuing the group
                if (seenCategoryKeys[seenCategoryKeys.length - 1] === key) {
                    lastSeenIndex[key] = index;
                    return { ...subcat, invalid: false };
                } else {
                    // It's reappearing after other groups appeared in between — INVALID
                    return { ...subcat, invalid: true };
                }
            }
        });

        return updatedSubcategories;
    };

    validateSubcategoryOrder = (subcategories) => {
        const seenCategoryKeys = [];
        const categoryKeyMap = subcategories.map(subcat =>
            `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`
        );

        for (let i = 0; i < categoryKeyMap.length; i++) {
            const key = categoryKeyMap[i];

            // If it's a new key, push it
            if (!seenCategoryKeys.includes(key)) {
                seenCategoryKeys.push(key);
            } else {
                // If key was seen earlier and is not the most recent, it's an interleaving
                if (seenCategoryKeys[seenCategoryKeys.length - 1] !== key) {
                    return false; // Invalid order
                }
            }
        }

        return true; // Valid order
    };

    onSplashScreenTextChange = value => {
        this.setState({ splashTextEditorObj: value });
        let enteredString = TextEditor.getHTMLStringFromEditorState(value);
        if (enteredString !== null) {
            this.setState({ splashScreenText: enteredString });
        }
        var imgTagCount = enteredString.split('<img ').length - 1
        if (imgTagCount >= 1) {
            this.setState({
                altSplashScreenTextVisible: true,
                imgTagCount: imgTagCount
            })
        }
        if (imgTagCount < 1) {
            this.setState({
                altSplashScreenTextVisible: false,
                imgTagCount: imgTagCount,
            })
        }
    };

    handleChangeStartDate = (timeString, sDate, event) => {
        if (sDate !== null) {
            this.setState({
                startDate: moment(sDate)
            });
        }
    }

    handleChangeEndDate = (eDate, id) => {
        if (eDate !== null) {
            let date = moment(eDate)
            if (id === "date") {
                date.set({ "h": 23, "m": 59 })
            }
            this.setState({
                endDate: date
            });
        }
    }


    handleSectionSelect = (event) => {
        let selectedSectionIDArr = event.target.value;
        this.setState({
            selectedSectionIDArr,
        })
    }

    onSaveCategoryOption = (updatedCategories, freeChoiceCount) => {

        //console.debug("updatedCategories>>??", updatedCategories)

        let updatedSubcategories = [];

        const atFirstKeys = new Set();
        const atLastKeys = new Set();

        updatedCategories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            if (cat.atFirst) atFirstKeys.add(key);
            else if (cat.atLast) atLastKeys.add(key);
        });

        let middleSubcats = [];
        let lastSubcats = [];
        let order = 1;

        this.state.subcategories.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

            if (atFirstKeys.has(key)) {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            } else if (atLastKeys.has(key)) {
                lastSubcats.push(subcat);
            } else {
                middleSubcats.push(subcat);
            }
        });

        middleSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        lastSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        this.setState({
            categories: updatedCategories,
            showCategoryOptions: false,
            freeChoiceCount: freeChoiceCount
        }, () => {
            this.setState({ subcategories: updatedSubcategories });
        });
    }

    handlePreviewClick = () => {
        let strToRemove = 'cpanel/'
        let url = (this.appProperties.appURL)
        url = url.replace(strToRemove, "");
        if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
            let hostArray = window.location.hostname.split(".");
            if (hostArray.length > 4) {
                url = `${window.location.protocol}//${hostArray[hostArray.length - 5]}.student.${hostArray[hostArray.length - 3]}.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
            } else if (hostArray.length == 4) {
                url = `${window.location.protocol}//${hostArray[hostArray.length - 4]}.student.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/`
            }
        }
        if (this.appProperties.loginType === "shiboleth") {
            url = url + "student/";
        }

        // Validation
        if (this.state.selectedSectionIDArr.length === 0) {
            NotificationManager.error("Please select a section and save the assignment to preview it.", "ERROR", 3000);
            return;
        }

        if (this.state.categories.length === 0) {
            NotificationManager.error("Please add atleast one category/subcategory", "ERROR", 3000);
            return;
        }


        let selectSectionID = "";
        if (this.state.selectedSectionIDArr && this.state.selectedSectionIDArr.length) {
            selectSectionID = this.state.selectedSectionIDArr[0];
        }

        // For local dev 
        if (url.includes("localhost")) {
            url = url.replace("3000", "3001/");
        }

        url = url + `takequiz?quiz_id=${this.state.assignment.quiz_id}&course_id=${this.state.assignment.course_id}&section_id=${selectSectionID}&quiz_name=${this.state.assignment.quiz_name}&quiz_type=${this.state.assignment.quiz_type}`

        console.log("AppURL=", url)
        window.open(url)
    }

    handleRemoveSubcategory = (index) => {
        let updatedSubcategories = [...this.state.subcategories];
        updatedSubcategories.splice(index, 1);
        this.changeSubcategoriesOrder(updatedSubcategories);
    }

    changeSubcategoriesOrder = (subcategories) => {
        // Based on subcategories at first and at last
        // change the order 
        let updatedSubcategories = []

        const atFirstKeys = new Set();
        const atLastKeys = new Set();

        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            if (cat.atFirst) atFirstKeys.add(key);
            else if (cat.atLast) atLastKeys.add(key);
        });

        let middleSubcats = [];
        let lastSubcats = [];
        let order = 1;

        subcategories.forEach(subcat => {
            const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

            if (atFirstKeys.has(key)) {
                updatedSubcategories.push({
                    ...subcat,
                    order: order++,
                });
            } else if (atLastKeys.has(key)) {
                lastSubcats.push(subcat);
            } else {
                middleSubcats.push(subcat);
            }
        });

        middleSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        lastSubcats.forEach(subcat => {
            updatedSubcategories.push({
                ...subcat,
                order: order++,
            });
        });

        let updatedCategories = [];
        this.state.categories.forEach(cat => {
            const key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
            // check if key is present in sucbategories
            let index = updatedSubcategories.findIndex(subcat => {
                let subcatKey = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                return subcatKey === key;
            })
            if (index !== -1) {
                updatedCategories.push(cat);
            }
        })

        this.setState({
            categories: updatedCategories,
            subcategories: updatedSubcategories,
        })
    }

    onSaveSectionSubsection = (data, editMode) => {
        let selectedSectionAndSubsectionList = [...this.state.selectedSectionAndSubsectionList];
        if (editMode) {
            let index = selectedSectionAndSubsectionList.findIndex(sec => sec.section_id === data.section_id);
            if (index > -1) {
                selectedSectionAndSubsectionList[index] = data;
            }
        } else {
            selectedSectionAndSubsectionList.push(data);
        }
        this.setState({
            selectedSectionAndSubsectionList,
        })
    }

    onDeleteSectionSubsection = (index) => {
        if (index > -1) {
            let selectedSectionAndSubsectionList = [...this.state.selectedSectionAndSubsectionList];
            selectedSectionAndSubsectionList.splice(index, 1);
            this.setState({
                selectedSectionAndSubsectionList,
            })
        }
    }

    render() {
        let seenCategoryKeys = new Set();
        const { assignment } = this.state;

        let categoryMasteryCountJSON = assignment?.category_mastery_count ? JSON.parse(assignment.category_mastery_count) : {};
        let categoryNocqcJSON = assignment?.category_nocqc ? JSON.parse(assignment.category_nocqc) : {};
        let randomSubcategoryOrderJSON = assignment?.random_subcategory_order ? JSON.parse(assignment.random_subcategory_order) : {};
        let categoryIsRequiredJSON = assignment?.category_is_required ? JSON.parse(assignment.category_is_required) : {};
        let categoryPositionJSON = assignment?.category_position ? JSON.parse(assignment.category_position) : {};


        let startDateLocal = moment(this.state.startDate).toDate();
        let endtDateLocal = moment(this.state.endDate).toDate();

        const isValidDate = function (d) {
            return d instanceof Date && !isNaN(d);
        }

        //console.debug("this.state.selectedSectionIDArr>>??", this.state.selectedSectionIDArr)

        return (
            <Dialog
                open={this.props.showModal}
                // fullWidth
                // maxWidth="lg"
                fullScreen
                className='assign-detail-dialog'
            >
                <DialogTitle style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>
                    <Typography fontSize={18} fontWeight={600}>
                        {assignment?.quiz_name} - Details:
                    </Typography>
                    {this.state.assignment.quiz_id !== null ?
                        <Button
                            style={{
                                marginRight: "2rem"
                            }}
                            variant='contained' onClick={this.handlePreviewClick}>
                            Preview
                        </Button>
                        : null}
                </DialogTitle>

                <Tooltip
                    title={<Typography className='text-white' fontSize={14}>
                        Close
                    </Typography>}
                    placement='top'
                    arrow
                >
                    <IconButton
                        aria-label="close"
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        })}
                        onClick={this.props.handleClose}
                    >
                        <IoMdCloseCircleOutline fontSize={24} />
                    </IconButton>
                </Tooltip>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <div style={{
                                fontWeight: 600,
                            }}>Assignment Name</div>
                            <TextField
                                size='small'
                                placeholder='Enter assignment name'
                                value={assignment?.quiz_name}
                                onChange={e => {
                                    let updatedValue = e.target.value;
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            quiz_name: updatedValue,
                                        }
                                    }));
                                }}
                                variant="standard"
                                id="assignment-name"
                                sx={{
                                    width: "100%",
                                    '& .MuiInputBase-root': {
                                        height: '40px',
                                        borderRadius: '6px'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <DatePicker
                                id="startDate"
                                label="Start Date"
                                displayMode="portrait"
                                value={isValidDate(startDateLocal) ? startDateLocal : null}
                                onChange={this.handleChangeStartDate}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TimePicker
                                id="startTime"
                                label="Start Time"
                                displayMode="portrait"
                                value={isValidDate(startDateLocal) ? startDateLocal : null}
                                onChange={this.handleChangeStartDate}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <DatePicker
                                id="endDate"
                                label="End Date"
                                displayMode="portrait"
                                value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                onChange={(_, date) => this.handleChangeEndDate(date, "date")}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TimePicker
                                id="endTime"
                                label="End Time"
                                displayMode="portrait"
                                value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                onChange={(_, date) => this.handleChangeEndDate(date, "time")}
                            />
                        </Grid>
                    </Grid>

                    {/* 2nd row */}
                    <div className='row-containers'>
                        {/* Common items */}
                        <Box component="fieldset" className='row-containers'>
                            <legend>Common</legend>
                            <div className='checkbox-container' onClick={() => {
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        randomize_categories: prevState.assignment?.randomize_categories === 1 ? 0 : 1,
                                    }
                                }));
                            }}>
                                <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.randomize_categories === 1} icons={false} className='custom-react-toggle' />
                                <Header name="Random Category Order" tooltip={this.helpTextModel.getHelpTextForKey('Random category order')} />
                            </div>
                            <div className='checkbox-container' onClick={() => {
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        is_nongraded: prevState.assignment?.is_nongraded === 1 ? 0 : 1,
                                    }
                                }));
                            }}>
                                <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.is_nongraded === 1} icons={false} className='custom-react-toggle' />
                                <Header name="Non Graded" tooltip={"If Enabled, Score will not be evaluated in Gradebook Total score or Mean score."} />
                            </div>
                            <div className='checkbox-container' onClick={() => {
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        is_anonymous: prevState.assignment?.is_anonymous === 1 ? 0 : 1,
                                    }
                                }));
                            }}>
                                <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.is_anonymous === 1} icons={false} className='custom-react-toggle' />
                                <Header name="Anonymous" tooltip={<div style={{ padding: "0 8px" }}>
                                    <ul className='anonymous-tooltip'>
                                        <li>If enabled, anyone with anonymous link can attend the assignment without having to register to Stemfluency.</li>
                                        <li>Anyone registered with Stemfluency who takes this assignment remains anonymous.</li>
                                    </ul>
                                </div>} />
                            </div>
                            <div className='checkbox-container' onClick={() => {
                                /* this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        quiz_type: prevState.assignment?.quiz_type === 1 ? 0 : 1,
                                    }
                                })); */
                            }}>
                                <FormControl >
                                    {/* <FormLabel>Assignment</FormLabel> */}
                                    <RadioGroup
                                        row
                                        value={assignment?.quiz_type}
                                        name="row-radio-buttons-group"
                                        style={{
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                        onChange={() => {
                                            this.setState(prevState => ({
                                                assignment: {
                                                    ...prevState.assignment,
                                                    quiz_type: prevState.assignment?.quiz_type === 1 ? 0 : 1,
                                                }
                                            }));
                                        }}
                                    >
                                        <FormControlLabel value={0} control={<Radio />} label="Mastery" />
                                        <FormControlLabel value={1} control={<Radio />} label="Test" />
                                        <Tooltip
                                            title={<Typography className='text-white' fontSize={14}>
                                                {this.helpTextModel.getHelpTextForKey('Test Mode')}
                                            </Typography>}
                                            placement='top'
                                            arrow
                                        >
                                            <span>
                                                <BsInfoCircleFill color='#737373' size={14}
                                                    style={{
                                                        flexShrink: 0,
                                                        minWidth: "12px",
                                                        minHeight: "12px",
                                                        verticalAlign: "middle",
                                                        cursor: "pointer",
                                                    }} />
                                            </span>
                                        </Tooltip>
                                    </RadioGroup>
                                </FormControl>
                                {/* <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.quiz_type === 1} icons={false} className='custom-react-toggle' />
                                <Header name="Test" tooltip={this.helpTextModel.getHelpTextForKey('Test Mode')} /> */}
                            </div>
                        </Box>

                        {/* Quiz Related */}
                        {assignment?.quiz_type === 0 ?
                            <Box component="fieldset" className='row-containers'>
                                <legend>Quiz</legend>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            allow_partial_credit: prevState.assignment?.allow_partial_credit === 1 ? 0 : 1,
                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.allow_partial_credit} icons={false} className='custom-react-toggle' />
                                    <Header name="Allow Partial Credit" tooltip={this.helpTextModel.getHelpTextForKey('Allow Partial Credit')} />
                                </div>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            allow_pause_category: prevState.assignment?.allow_pause_category === 1 ? 0 : 1,
                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.allow_pause_category} icons={false} className='custom-react-toggle' />
                                    <Header name="Allow Pause Category" tooltip={this.helpTextModel.getHelpTextForKey('Allow Pause Category')} />
                                </div>
                            </Box>
                            : null}

                        {/* Test Related  */}
                        {assignment?.quiz_type === 1 ?
                            <Box component="fieldset" className='row-containers'>
                                <legend>Test</legend>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            one_page_mode: prevState.assignment?.one_page_mode === 1 ? 0 : 1,
                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.one_page_mode === 1} icons={false} className='custom-react-toggle' />
                                    <Header name="One Page Mode" tooltip={"All questions are shown at once. When turned ON, all randomization should be turned OFF"} />
                                </div>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            full_score_if_attempted: prevState.assignment?.full_score_if_attempted === 1 ? 0 : 1,

                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.full_score_if_attempted === 1} icons={false} className='custom-react-toggle' />
                                    <Header name="Award full score if completed" tooltip={this.helpTextModel.getHelpTextForKey('Award full score if completed')} />
                                </div>
                                <div className='checkbox-container' onClick={() => {
                                    this.setState(prevState => ({
                                        assignment: {
                                            ...prevState.assignment,
                                            testTimerEnabled: prevState.assignment?.testTimerEnabled === 1 ? 0 : 1,

                                        }
                                    }));
                                }}>
                                    <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.testTimerEnabled === 1} icons={false} className='custom-react-toggle' />
                                    <Header name="Test Time" tooltip={this.helpTextModel.getHelpTextForKey('Test Time')} />
                                </div>
                                {assignment?.testTimerEnabled === 1 ?
                                    <div>
                                        <div className='checkbox-container' onClick={() => {
                                            this.setState(prevState => ({
                                                assignment: {
                                                    ...prevState.assignment,
                                                    fixedAbsoluteTimeEnabled: prevState.assignment?.fixedAbsoluteTimeEnabled === 1 ? 0 : 1,
                                                }
                                            }));
                                        }}>
                                            <Toggle onClick={(e) => e.stopPropagation()} checked={assignment?.fixedAbsoluteTimeEnabled === 1} icons={false} className='custom-react-toggle' />
                                            <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Fixed Timer</div>
                                        </div>
                                        <div className='textfield-container'>
                                            <Header name="in min" />
                                            <TextField
                                                onChange={(e) => {
                                                    let updatedValue = parseInt(e.target.value);
                                                    if (updatedValue <= 0) updatedValue = 1;
                                                    this.setState(prevState => ({
                                                        assignment: {
                                                            ...prevState.assignment,
                                                            test_time: updatedValue,
                                                        }
                                                    }));
                                                }} value={assignment?.test_time} type='number' size='small' sx={{ width: "60px" }} />
                                        </div>
                                    </div>
                                    : null}
                            </Box>
                            : null}
                    </div>


                    {/* 3rd row */}
                    <div className='row-containers'>
                        <div className='textfield-container'>
                            <Header name="Default Mastery" tooltip={this.helpTextModel.getHelpTextForKey('Default Mastery')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        mastery_condition: updatedValue,
                                    }
                                }));
                            }} value={assignment?.mastery_condition} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        <div className='textfield-container'>
                            <Header name="Max. Attempts" tooltip={this.helpTextModel.getHelpTextForKey('Max Attempts')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        maximum_attempted: updatedValue,
                                    }
                                }));
                            }} value={assignment?.maximum_attempted} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        <div className='textfield-container'>
                            <Header name="NOCQC" tooltip={this.helpTextModel.getHelpTextForKey('NOCQC')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        NoCQC: updatedValue,
                                    }
                                }));
                            }} value={assignment?.NoCQC} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        <div className='textfield-container'>
                            <Header name="Lock Out" tooltip={this.helpTextModel.getHelpTextForKey('LockOut')} />
                            <TextField onChange={(e) => {
                                let updatedValue = parseInt(e.target.value);
                                if (updatedValue <= 0) updatedValue = 1;
                                this.setState(prevState => ({
                                    assignment: {
                                        ...prevState.assignment,
                                        lockoutN: updatedValue,
                                    }
                                }));
                            }} value={assignment?.lockoutN} type='number' size='small' sx={{ width: "60px" }} />
                        </div>
                        {this.state.enableSubSection ?
                            <div className='section-container'>
                                <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Section List</div>
                                <Button variant='contained' onClick={() => {
                                    this.setState({
                                        showSectionsAndSubsectionsDialog: true
                                    })
                                }}>
                                    Sections & Subsections
                                </Button>
                            </div>
                            :
                            <div className='section-container'>
                                <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Section List</div>
                                <FormControl fullWidth>
                                    <Select
                                        size='small'
                                        id="section-id"
                                        multiple
                                        value={this.state.selectedSectionIDArr}
                                        onChange={this.handleSectionSelect}
                                        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => {
                                                    let section = this.state.sections.find(sec => sec.section_id === value);
                                                    return (
                                                        <Chip className='custom-chip' key={value} label={section?.section_name} />
                                                    )
                                                })}
                                            </Box>
                                        )}
                                    >
                                        {this.state.sections?.map((section, index) => {
                                            return (
                                                <MenuItem key={index} value={section.section_id}>
                                                    {section.section_name}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                        }
                        {this.state.hasSubSections ?
                            <div className='textfield-container'>
                                <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>Enable Subsections</div>
                                <Toggle checked={this.state.enableSubSection} icons={false} className='custom-react-toggle'
                                    onChange={() => {
                                        this.setState({
                                            selectedSectionIDArr: [],
                                            selectedSectionAndSubsectionList: [],
                                            enableSubSection: !this.state.enableSubSection
                                        })
                                    }}
                                />
                            </div>
                            : null}
                    </div>

                    {/* Choosen category/subcategory table */}
                    <div style={{ marginTop: "3rem", marginBottom: "1rem", display: "flex", gap: '1rem' }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%" }}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", gap: "1rem" }}>
                                <Typography fontSize={16} fontWeight={600}>Chosen Categories/Subcategories Table:</Typography>
                                <div className='button-flex'>
                                    <Button variant='contained' onClick={() => this.setState({
                                        showCategoryOptions: true,
                                    })}>
                                        Category Options
                                    </Button>
                                    <Tooltip
                                        title={<Typography className='text-white' fontSize={14}>
                                            {this.helpTextModel.getHelpTextForKey('Category Options')}
                                        </Typography>}
                                        placement='top'
                                        arrow
                                    >
                                        <span>
                                            <BsInfoCircleFill color='#737373' size={14}
                                                style={{
                                                    flexShrink: 0,
                                                    minWidth: "12px",
                                                    minHeight: "12px",
                                                    verticalAlign: "middle",
                                                    cursor: "pointer",
                                                }} />
                                        </span>
                                    </Tooltip>
                                </div>
                                <div className='button-flex'>
                                    <Button variant='contained' onClick={() => this.setState({
                                        showEditDueDates: true,
                                    })}>
                                        Edit Due Date and Locks
                                    </Button>
                                    <Tooltip
                                        title={<Typography className='text-white' fontSize={14}>
                                            {this.helpTextModel.getHelpTextForKey('Edit Due Dates')}
                                        </Typography>}
                                        placement='top'
                                        arrow
                                    >
                                        <span>
                                            <BsInfoCircleFill color='#737373' size={14}
                                                style={{
                                                    flexShrink: 0,
                                                    minWidth: "12px",
                                                    minHeight: "12px",
                                                    verticalAlign: "middle",
                                                    cursor: "pointer",
                                                }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                            <div style={{ fontSize: '1rem', fontWeight: '600' }}>
                                Mastery Units: <span>{assignment?.mastery_units}</span>
                            </div>
                        </div>
                    </div>
                    <div className='matrix-table-container main-catsubcat-table'>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <table className='matrix-table' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead className='matrix-table-head'>
                                    <tr className="matrix-row-header">
                                        <th className="matrix-row-cell" style={{ width: "50px" }}></th>
                                        <th className="matrix-row-cell" style={{ minWidth: "150px" }}>Subjects</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "150px" }}>Topics</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "200px" }}>Categories</th>
                                        <th className="matrix-row-cell" style={{ minWidth: "200px" }}>Subcategories</th>
                                        <th
                                            key={0}
                                            className="matrix-row-cell"
                                            style={{
                                                minWidth: "140px",
                                            }}
                                        >
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                <Header name="Random question order" tooltip={this.helpTextModel.getHelpTextForKey('Random question order')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}
                                        >
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name="NOCQSC" tooltip={this.helpTextModel.getHelpTextForKey('Weights')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "130px",
                                            }}>
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                <Header name="Available Questions" tooltip={this.helpTextModel.getHelpTextForKey('Available_Subcategory_Questions')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name="Graded" tooltip={this.helpTextModel.getHelpTextForKey('Graded')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "120px",
                                            }}>
                                            <div className='category-header-tag cat-cell' onClick={() => { }}>
                                                <Header name="Enable Analytics" tooltip={this.helpTextModel.getHelpTextForKey('Enable Analytics')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "120px",
                                            }}>
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                <Header name="Enable Feedback" tooltip={this.helpTextModel.getHelpTextForKey('Enable Feedback')} />
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "100px",
                                            }}>
                                            <div className='category-header-tag cat-cell text-align-center' onClick={() => { }}>
                                                Display Order
                                            </div>
                                        </th>
                                        <th className="matrix-row-cell"
                                            style={{
                                                minWidth: "80px",
                                            }}>
                                            <div className='category-header-tag cat-cell'>
                                                Actions
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <Droppable droppableId="subCategories">
                                    {(provided) => (
                                        <tbody
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                        >
                                            {this.state.subcategories?.map((subcat, index) => {
                                                //console.debug("subcat>>??", subcat)
                                                let subcategoryID = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}_${subcat.subcategory_id}`
                                                let nocqc = 1;
                                                if (subcat?.subcategory_weight) nocqc = subcat?.subcategory_weight;

                                                const l = this.state.subcategories.length;
                                                const currentCatKey = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;
                                                let isAtFirst = false;
                                                let isAtLast = false;

                                                let category = this.state.categories.find(cat => {
                                                    let catKey = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                                                    return catKey === currentCatKey;
                                                })

                                                if (category) {
                                                    isAtFirst = category.atFirst === 1;
                                                    isAtLast = category.atLast === 1;
                                                }

                                                const hideUpArrow = index === 0;
                                                const hideDownArrow = index === l - 1;

                                                let upBtnDisabled = isAtFirst || isAtLast;
                                                let downBtnDisabled = upBtnDisabled;

                                                // Check if its previous is a different category and it has atFirst
                                                if (index > 0) {
                                                    const prevSubcat = this.state.subcategories[index - 1];
                                                    let prevCat = this.state.categories.find(c => {
                                                        let k = `${c.subject_id}_${c.topic_id}_${c.category_id}`;
                                                        return k === `${prevSubcat.subject_id}_${prevSubcat.topic_id}_${prevSubcat.category_id}`;
                                                    })
                                                    if (prevCat.atFirst === 1) {
                                                        upBtnDisabled = true;
                                                    }
                                                }

                                                if (index < l - 1) {
                                                    const nextSubcat = this.state.subcategories[index + 1];
                                                    let nextCat = this.state.categories.find(c => {
                                                        let k = `${c.subject_id}_${c.topic_id}_${c.category_id}`;
                                                        return k === `${nextSubcat.subject_id}_${nextSubcat.topic_id}_${nextSubcat.category_id}`;
                                                    })

                                                    if (nextCat.atLast === 1) {
                                                        downBtnDisabled = true;
                                                    }
                                                }

                                                /* if (!hideUpArrow && index > 0) {
                                                    const prevSubcat = this.state.subcategories[index - 1];
                                                    const prevCatKey = `${prevSubcat.subject_id}_${prevSubcat.topic_id}_${prevSubcat.category_id}`;
    
                                                    if (currentCatKey === prevCatKey) {
                                                        upBtnDisabled = false;
                                                    }
                                                }
    
                                                // Check DOWN
                                                if (!hideDownArrow && index < l - 1) {
                                                    const nextSubcat = this.state.subcategories[index + 1];
                                                    const nextCatKey = `${nextSubcat.subject_id}_${nextSubcat.topic_id}_${nextSubcat.category_id}`;
    
                                                    if (currentCatKey === nextCatKey) {
                                                        downBtnDisabled = false;
                                                    }
                                                } */

                                                //console.debug("upBtnDisabled, downBtnDisabled", upBtnDisabled, downBtnDisabled)

                                                const atFirstTooltip = `Moving up is disabled\nbecause this category\nis checked either\nAt first or At last\nin category options`;
                                                const atLastTooltip = `Moving down is disabled\nbecause this category\nis checked either\nAt First or At last\nin category options`;

                                                let dragDisabled = upBtnDisabled || downBtnDisabled;
                                                const dragDisableMsg = "Dragging is disabled\nbecause this category\nis checked either\nAt first or At last\nin category option"

                                                return (
                                                    <Draggable
                                                        key={subcategoryID}
                                                        draggableId={subcategoryID}
                                                        index={index}
                                                        isDragDisabled={dragDisabled}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <tr
                                                                className={`matrix-row ${subcat.invalid ? "invalid-subcat" : ""}`}
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    width: "fit-content",
                                                                    backgroundColor: snapshot.isDragging ? "white" : "inherit",
                                                                    boxShadow: snapshot.isDragging
                                                                        ? "0 4px 12px rgba(0,0,0,0.15)"
                                                                        : "none",
                                                                    // cursor: "grab",
                                                                    transition: "background-color 0.2s ease",
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                <td className="matrix-row-cell drag-cell" style={{ minWidth: "50px" }}>
                                                                    <Tooltip
                                                                        disableHoverListener={!dragDisabled}
                                                                        title={<Typography className='text-white' fontSize={14}>
                                                                            {dragDisableMsg}</Typography>}>

                                                                        <MdDragIndicator fontSize={26}
                                                                            style={{
                                                                                cursor: dragDisabled ? "not-allowed" : "grab",
                                                                                color: dragDisabled ? "#a7a7a7" : "#333",
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "150px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.subject_name}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "150px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.topic_name}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.category_Name}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ textAlign: 'left', minWidth: "200px" }}>
                                                                    <div className='category-name-cell'>
                                                                        <div className='category-name'>
                                                                            {subcat.subcategory_name}
                                                                            {/* ({subcat.order}) */}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "120px" }}>
                                                                    <Toggle checked={subcat?.randomize_questions === 1} icons={false}
                                                                        onChange={() => {
                                                                            let updatedValue = subcat?.randomize_questions === 1 ? 0 : 1;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].randomize_questions = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                        className='custom-react-toggle' />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <div style={{ padding: "6px" }}>
                                                                        <TextField size='small'
                                                                            sx={{
                                                                                width: "50px",
                                                                            }}

                                                                            value={nocqc}
                                                                            type='number'
                                                                            onChange={(e) => {
                                                                                let updatedValue = parseInt(e.target.value);
                                                                                if (updatedValue <= 0) updatedValue = 1;
                                                                                let updatedSubcategories = [...this.state.subcategories];
                                                                                updatedSubcategories[index].subcategory_weight = updatedValue;
                                                                                this.setState({ subcategories: updatedSubcategories });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    {subcat.question_count}
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "80px" }}>
                                                                    <Toggle checked={subcat.non_graded === 0} icons={false} className='custom-react-toggle'
                                                                        onChange={() => {
                                                                            let updatedValue = subcat?.non_graded === 1 ? 0 : 1;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].non_graded = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <Toggle checked={subcat.enable_analytics} icons={false} className='custom-react-toggle'
                                                                        onChange={() => {
                                                                            let updatedValue = !subcat.enable_analytics;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].enable_analytics = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <Toggle checked={subcat.enable_feedback} icons={false} className='custom-react-toggle'
                                                                        onChange={() => {
                                                                            let updatedValue = !subcat.enable_feedback;
                                                                            let updatedSubcategories = [...this.state.subcategories];
                                                                            updatedSubcategories[index].enable_feedback = updatedValue;
                                                                            this.setState({ subcategories: updatedSubcategories });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "100px" }}>
                                                                    <div className='display-order'>
                                                                        {hideUpArrow ? <div></div> :
                                                                            <Tooltip title={<Typography className='text-white' fontSize={14}>
                                                                                {atFirstTooltip}
                                                                            </Typography>} placement="top" arrow
                                                                                disableHoverListener={!upBtnDisabled}
                                                                            >
                                                                                <IconButton onClick={() => {
                                                                                    if (upBtnDisabled) return;
                                                                                    let updatedSubcategories = [...this.state.subcategories];

                                                                                    let currentSubcat = { ...updatedSubcategories[index] };
                                                                                    let prevSubcat = { ...updatedSubcategories[index - 1] };
                                                                                    let tempOrder = currentSubcat.order;

                                                                                    currentSubcat.order = prevSubcat.order;
                                                                                    prevSubcat.order = tempOrder;

                                                                                    updatedSubcategories[index] = prevSubcat;
                                                                                    updatedSubcategories[index - 1] = currentSubcat;

                                                                                    updatedSubcategories = this.markInvalidSubcategoryOrder(updatedSubcategories);

                                                                                    this.setState({ subcategories: updatedSubcategories });
                                                                                }}>
                                                                                    <PiCaretUpBold color={`${upBtnDisabled ? "#a7a7a7" : "#bb0000"}`} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        }

                                                                        {hideDownArrow ? <div></div> :
                                                                            <Tooltip title={<Typography className='text-white' fontSize={14}>
                                                                                {atLastTooltip}
                                                                            </Typography>} placement="top" arrow
                                                                                disableHoverListener={!downBtnDisabled}
                                                                            >
                                                                                <IconButton onClick={() => {
                                                                                    if (downBtnDisabled) return;
                                                                                    let updatedSubcategories = [...this.state.subcategories];

                                                                                    let currentSubcat = { ...updatedSubcategories[index] };
                                                                                    let nextSubcat = { ...updatedSubcategories[index + 1] };
                                                                                    let tempOrder = currentSubcat.order;

                                                                                    currentSubcat.order = nextSubcat.order;
                                                                                    nextSubcat.order = tempOrder;

                                                                                    updatedSubcategories[index] = nextSubcat;
                                                                                    updatedSubcategories[index + 1] = currentSubcat;

                                                                                    updatedSubcategories = this.markInvalidSubcategoryOrder(updatedSubcategories);

                                                                                    this.setState({ subcategories: updatedSubcategories });
                                                                                }}>
                                                                                    <PiCaretDownBold color={`${downBtnDisabled ? "#a7a7a7" : "#bb0000"}`} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className="matrix-row-cell" style={{ minWidth: "80px" }}>
                                                                    <IconButton onClick={() => {
                                                                        this.handleRemoveSubcategory(index)
                                                                    }}>
                                                                        <IoIosCloseCircle color='#bb0000' />
                                                                    </IconButton>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                )
                                            })}
                                            {provided.placeholder}
                                        </tbody>
                                    )}
                                </Droppable>
                            </table>
                        </DragDropContext>
                    </div>


                    {/* Final row */}
                    <Typography fontSize={16} fontWeight={600} marginTop={0} marginBottom={1}>Splash Screen:</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <div className='w-100 splash-screen-container'>
                                <TextEditor className="custom-text-editor"
                                    value={this.state.splashTextEditorObj}
                                    onChange={this.onSplashScreenTextChange}
                                    placeholder="Enter splash screen text"
                                />
                                {this.state.altSplashScreenTextVisible ?
                                    <div style={{ marginTop: "1rem" }}>
                                        <p style={{ fontSize: "medium", color: '#bb0000' }}><label for="altsplashId">
                                            <span style={{ marginRight: "4px" }}>
                                                Title and Alternative Text for all Images in SplashScreen
                                            </span>
                                            <Tooltip
                                                title={<Typography className='text-white' fontSize={14}>
                                                    Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt.
                                                </Typography>}
                                                placement='top'
                                                arrow
                                            >
                                                <span>
                                                    <BsInfoCircleFill color='#737373' size={14}
                                                        style={{
                                                            flexShrink: 0,
                                                            minWidth: "12px",
                                                            minHeight: "12px",
                                                            verticalAlign: "middle",
                                                            cursor: "pointer",
                                                        }} />
                                                </span>
                                            </Tooltip>
                                        </label></p>

                                        <TextField
                                            value={this.state.altSplashScreenText}
                                            onChange={e => {
                                                this.setState({ altSplashScreenText: e.target.value })
                                            }}
                                            style={{
                                                width: "450px"
                                            }}
                                            id="altsplashId"
                                            name='altSplashScreenEditor'
                                        />
                                    </div>
                                    : null}
                            </div>
                        </Grid>
                        <Grid item xs={6} className='footer-btn-container'>
                            <Button disabled={this.state.saveLoading} variant='contained'
                                onClick={() => {
                                    this.handleSaveClick(0)
                                }}
                                className='button-container'>
                                <div style={{ opacity: this.state.saveLoading ? 0 : 1 }}>
                                    Save
                                </div>
                                <div className='abs-center'>
                                    {this.state.saveLoading && (
                                        <CircularProgress size={20} />
                                    )}
                                </div>
                            </Button>
                            {assignment.status === 0 ?
                                <Button variant='contained' disabled={this.state.saveLoading}
                                    onClick={() => {
                                        this.handleSaveClick(1)
                                    }}
                                >Save & Publish</Button>
                                : null}
                            <Button variant='outlined' disabled={this.state.saveLoading} onClick={this.props.handleClose}>Close</Button>
                        </Grid>
                    </Grid>

                    {this.state.showCategoryOptions ?
                        <CategoryOptionsModal
                            showModal={this.state.showCategoryOptions}
                            handleClose={() => this.setState({ showCategoryOptions: false })}
                            assignment={assignment}
                            categoriesArr={this.state.categories}
                            onSaveCategoryOption={this.onSaveCategoryOption}
                            fcCount={this.state.freeChoiceCount}
                        />
                        : null}


                    {/* Edit due date and locks  */}
                    {this.state.showEditDueDates ?
                        <EditDueDataDialog
                            showDialog={this.state.showEditDueDates}
                            handleClose={() => this.setState({ showEditDueDates: false })}
                            assignment={assignment}
                            sections={this.state.sections}
                            enableSubSection={this.state.enableSubSection}
                            selectedSectionIDArr={this.state.selectedSectionIDArr}
                        />
                        : null}

                    {/* Section and subection dialog table */}
                    {this.state.showSectionsAndSubsectionsDialog ?
                        <SectionSubsectionDialog
                            showDialog={this.state.showSectionsAndSubsectionsDialog}
                            selectedSectionAndSubsectionList={this.state.selectedSectionAndSubsectionList}
                            handleClose={() => this.setState({ showSectionsAndSubsectionsDialog: false })}
                            sections={this.state.sections}
                            subSections={this.state.subsections}
                            onSaveSectionSubsection={this.onSaveSectionSubsection}
                            onDeleteSectionSubsection={this.onDeleteSectionSubsection}
                        />
                        : null}

                </DialogContent >
            </Dialog >
        )
    };
}

const SectionSubsectionDialog = ({
    showDialog,
    handleClose,
    selectedSectionAndSubsectionList,
    sections,
    subSections,
    onSaveSectionSubsection,
    onDeleteSectionSubsection
}) => {

    const [showAddSubsection, setShowSubsection] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);

    return (
        <Dialog
            open={showDialog}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}>
                <Typography fontSize={18} fontWeight={500}>
                    Sections & Subsections Table
                </Typography>
                <Button
                    style={{
                        marginRight: "2rem"
                    }}
                    variant='contained' onClick={() => {
                        setShowSubsection(true);
                    }}>
                    Add Section & Subsection
                </Button>
            </DialogTitle>

            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>

            <DialogContent>
                <DataTable plain baseId="simple-pagination">
                    <TableHeader>
                        <TableRowReact>
                            <TableColumn className="SectionWidgetHeaderStyle">
                                Sections
                            </TableColumn>
                            <TableColumn className="SectionWidgetHeaderStyle">
                                SubSections
                            </TableColumn>
                            <TableColumn className="SectionWidgetHeaderStyle">
                                Actions
                            </TableColumn>
                        </TableRowReact>
                    </TableHeader>
                    <TableBody>
                        {selectedSectionAndSubsectionList?.map((rowData, index) => {
                            //console.debug("rowData>>??", rowData)
                            return (
                                <TableRowReact
                                    key={index}
                                    selectable={false} >
                                    <TableColumn className="quizTableColumn">
                                        {rowData.section_name}
                                    </TableColumn>

                                    {rowData.subsection?.length > 1 ? <CollapsableColumn
                                        data={rowData.subsection}
                                        className="quizTableColumn"
                                    >
                                    </CollapsableColumn> :
                                        <TableColumn className="quizTableColumn">
                                            {rowData.subsection ? rowData.subsection[0] : null}
                                        </TableColumn>}
                                    <TableColumn className="quizTableColumn">
                                        <Button icon tooltipLabel="Edit">
                                            <img src={editIcon} alt="Edit"
                                                onClick={() => {
                                                    setSelectedSection(rowData);
                                                    setShowSubsection(true);
                                                }}
                                            />
                                        </Button> {'  '}
                                        <Button icon tooltipLabel="Delete"
                                            onClick={() => {
                                                onDeleteSectionSubsection(index);
                                            }}
                                        >
                                            <img src={crossIcon} alt="Delete" />
                                        </Button>
                                    </TableColumn>
                                </TableRowReact>
                            )
                        })}
                    </TableBody>
                </DataTable>
            </DialogContent>

            {showAddSubsection ?
                <AddSubsectionDialog
                    showDialog={true}
                    sections={sections}
                    subSections={subSections}
                    handleClose={() => setShowSubsection(false)}
                    selectedSectionAndSubsectionList={selectedSectionAndSubsectionList}
                    selectedSection={selectedSection}
                    editMode={selectedSection !== null}
                    onSaveSectionSubsection={onSaveSectionSubsection}
                />
                : null}

        </Dialog>
    )
}


const AddSubsectionDialog = ({
    showDialog,
    handleClose,
    sections,
    subSections,
    selectedSection,
    editMode,
    selectedSectionAndSubsectionList,
    onSaveSectionSubsection
}) => {

    const [selectedSectionID, setSelectedSectionID] = useState(null);
    const [selectedSubsectionIDArr, setSelectedSubsectionIDArr] = useState([]);
    const [subSectionList, setSubSectionList] = useState([]);

    useEffect(() => {
        if (editMode) {
            setSelectedSectionID(selectedSection.section_id);
            setSelectedSubsectionIDArr(selectedSection.subsectionList.map(subSec => subSec.subsection_id));
            setSubSectionList(subSections.filter(subSec => subSec.section_id === selectedSection.section_id));
        }
    }, [])


    const handleSaveSectionSubsection = () => {
        //console.debug("selected>>??", selectedSectionID, selectedSubsectionIDArr)
        const section = sections.find(sec => sec.section_id === selectedSectionID);
        let data = {}
        let selecetedSubSections = subSectionList.filter(subSec => selectedSubsectionIDArr.includes(subSec.subsection_id));
        //console.debug("selecetedSubSections>>??", selecetedSubSections)
        if (section) {
            data = {
                section_id: selectedSectionID,
                section_name: section.section_name,
                subsectionList: selecetedSubSections,
                subsection: selecetedSubSections.map(subsection => subsection.subsection_name)
            }
        }

        let checkIfSectionIsAlreadyAddedIndex = selectedSectionAndSubsectionList.findIndex(sec => sec.section_id === data.section_id);
        if (checkIfSectionIsAlreadyAddedIndex > -1 && !editMode) {
            NotificationManager.error("This section is already added, please edit it");
        } else {
            onSaveSectionSubsection(data, editMode);
            handleClose();
        }
    }

    return (
        <Dialog
            open={showDialog}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    {editMode ? "Edit" : "Add"} Subsection
                </Typography>
            </DialogTitle>

            <DialogContent>
                <FormControl fullWidth variant="outlined" size="small" margin="dense">
                    <InputLabel id="id-section-label">Section</InputLabel>
                    <Select
                        id="id-section"
                        labelId="id-section-label"
                        label="Section"
                        value={selectedSectionID}
                        onChange={(e) => {
                            const value = e.target.value;
                            let filteredSubSections = subSections.filter(subSec => {
                                return subSec.section_id === value;
                            });
                            //console.debug("filteredSubSections>>??", filteredSubSections)
                            setSelectedSectionID(value);
                            setSubSectionList(filteredSubSections || []);

                        }}
                    >
                        {sections?.map((section, index) => (
                            <MenuItem key={index} value={section.section_id}>
                                {section.section_name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {selectedSectionID && (
                    <FormControl fullWidth variant="outlined" size="small" margin="dense">
                        <InputLabel id="id-sub-section-label">Subsection</InputLabel>
                        <Select
                            labelId="id-sub-section-label"
                            id="id-sub-section"
                            label="Subsection"
                            multiple
                            value={selectedSubsectionIDArr}
                            onChange={(e) => {
                                setSelectedSubsectionIDArr(e.target.value)
                            }}
                        >
                            {subSectionList?.map((subSection, index) => (
                                <MenuItem key={index} value={subSection.subsection_id}>
                                    {subSection.subsection_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="contained"
                    disabled={selectedSectionID === null || selectedSubsectionIDArr.length === 0}
                    onClick={handleSaveSectionSubsection}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>

    )
}

const EditDueDataDialog = ({
    showDialog,
    assignment,
    selectedSectionIDArr,
    sections,
    handleClose,
    enableSubSection
}) => {
    return (
        <Dialog
            open={showDialog}
            fullScreen
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    <b>{assignment?.quiz_name}</b> Configuration
                </Typography>
            </DialogTitle>
            <div style={{
                margin: "0rem 2rem",
                marginBottom: "12px",
            }}>
                Use this page to make changes to this Quiz that would affect an individual student or a section or a subsection
            </div>
            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>
            <EditWindow
                quizID={assignment.quiz_id}
                sectionList={
                    selectedSectionIDArr ?
                        selectedSectionIDArr.map(id => {
                            let section = sections.find(sec => sec.section_id === id)
                            if (section) {
                                return {
                                    label: section.section_name,
                                    id: section.section_id,
                                    value: true
                                }
                            }
                        })
                        : []
                }
                courseID={assignment.course_id}
                sectionID={assignment.section_id}
                isEnableSubsection={enableSubSection}
                selectedSectionAndSubsection={[]}
            />
        </Dialog>
    )
}

const Header = ({ name, tooltip }) => {
    return (

        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: "6px",
        }} >
            <div style={{ fontWeight: 600, width: "100%", paddingRight: "4px" }}>{name}</div>
            <Tooltip
                title={<Typography className='text-white' fontSize={14}>
                    {tooltip}
                </Typography>}
                placement='top'
                arrow
            >
                <span>
                    <BsInfoCircleFill color='#737373' size={14}
                        style={{
                            flexShrink: 0,
                            minWidth: "12px",
                            minHeight: "12px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                        }} />
                </span>
            </Tooltip>
        </div>
    )
}


export default AssignmentDetailModal;


